
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IInfoCardData, ISearchCriteria } from "@tylertech/tyler-api-types";

/**
 * EntitySearchService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class EntitySearchService {
    private readonly $apiService = inject(ApiService);
    
    GetCriteria(): Promise<ISearchCriteria<IInfoCardData>> {
        return this.$apiService.sendAuth("IEntitySearchService/GetCriteria");
    }
    Search(pCriteria: ISearchCriteria<IInfoCardData>): Promise<ISearchCriteria<IInfoCardData>> {
        return this.$apiService.sendAuth("IEntitySearchService/Search", pCriteria);
    }
    SearchPerCategory(pCriteria: ISearchCriteria<IInfoCardData>): Promise<ISearchCriteria<IInfoCardData>> {
        return this.$apiService.sendAuth("IEntitySearchService/SearchPerCategory", pCriteria);
    }
}
